//@flow
import { HiverAxios, showMessage } from 'h-commons';
import {
    GET_BILLING_ADDRESS_DONE,
    GET_BILLING_ADDRESS_FAILED,
    GET_BILLING_ADDRESS_INIT
} from './types';

export const getSetBillingAddress = (data: Object, hideToast: ?boolean) => (dispatch: Function) => {
    dispatch({
        type: GET_BILLING_ADDRESS_INIT
    });
    HiverAxios({
        url: '/api/account/payment/address',
        type: data ? 'POST' : 'GET',
        params: data,
        callback: response => {
            if (response.data && response.data.success) {
                dispatch({
                    type: GET_BILLING_ADDRESS_DONE,
                    payload: response.data.data || {}
                });
                if (data && !hideToast)
                    showMessage({
                        message: 'Billing address updated',
                        type: 'success'
                    })
            } else {
                dispatch({
                    type: GET_BILLING_ADDRESS_FAILED
                });
                if (data)
                    showMessage({
                        message: 'Billing address update failed. Please, try again.',
                        type: 'error'
                    })
            }
        }, onfail: () => {
            dispatch({
                type: GET_BILLING_ADDRESS_FAILED
            });
            if (data)
                showMessage({
                    message: 'Billing address update failed. Please, try again.',
                    type: 'error'
                })
        }
    });
}